// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1hBTV","col":"CardReaderDesc_col__19IPk","label":"CardReaderDesc_label__2p7mg"};